window.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.product-occupation').forEach(occupation => {
    const button = occupation.querySelector('.product-occupation-more');

    if (button) {
      button.addEventListener('click', e => {
        e.preventDefault();

        button.remove();

        occupation.querySelectorAll('.product-occupation-item-more').forEach(item => {
          item.classList.remove('product-occupation-item-more');
        });
      });
    }
  });
});